import { render, staticRenderFns } from "./CFormAttachment.vue?vue&type=template&id=cd547a1c&scoped=true&"
import script from "./CFormAttachment.vue?vue&type=script&lang=js&"
export * from "./CFormAttachment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd547a1c",
  null
  
)

export default component.exports